export default class GeoApi {
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(GeoApi.RegionsPath);
        this.DashAPI.ApiPathMgr.add(GeoApi.CitiesPath);
        this.DashAPI.ApiPathMgr.add(GeoApi.NeighborhoodsPath);
        this.DashAPI.ApiPathMgr.add(GeoApi.OfficesPath);
        this.DashAPI.ApiPathMgr.add(GeoApi.OfficeByIdPath);
        // this.DashAPI.ApiPathMgr.add(GeoApi.OpenHousePath);
    }

    getRegions() {
        return this.DashAPI.CORE.get(GeoApi.RegionsPath);
    }

    getCities() {
        return this.DashAPI.CORE.get(GeoApi.CitiesPath);
    }

    getCitiesByRegionId(regionId) {
        return this.DashAPI.CORE.get(GeoApi.RegionsPath + '/' + regionId + '/cities');
    }

    getCityById(cityId) {
        return this.DashAPI.CORE.get(GeoApi.CitiesPath + '/' + cityId);
    }

    getNeighborhoods() {
        return this.DashAPI.CORE.get(GeoApi.NeighborhoodsPath);
    }

    getNeighborhoodById(neighborhoodId) {
        return this.DashAPI.CORE.get(GeoApi.NeighborhoodsPath + '/' + neighborhoodId);
    }

    getOffices() {
        return this.DashAPI.CORE.get(GeoApi.OfficesPath);
    }

    getOfficeById(officeId) {
        return this.DashAPI.CORE.get(GeoApi.OfficesPath + '/' + officeId);
    }

    getRandomAreas(size) {
        return this.DashAPI.CORE.get(GeoApi.RandomPath, {size: size});
    }

    getRegionById(regionId) {
        return this.DashAPI.CORE.get(GeoApi.RegionsPath + '/' + regionId);
    }

    getAgentsByOfficeId(officeId) {
        return this.DashAPI.CORE.get(`${GeoApi.OfficesPath}/${officeId}/agents`);
    }

    getSFRDistricts() {
        return this.DashAPI.CORE.get(GeoApi.SFRDistrictPath);
    }

    getSitemap(){
        return this.DashAPI.CORE.getXML(GeoApi.SitemapPath);
    }

    getOfficesSitemap(){
        return this.DashAPI.CORE.getXML(GeoApi.OfficesSiteMap);
    }
}

GeoApi.RandomPath = '/api/geo/random';
GeoApi.SitemapPath = '/api/geo/sitemap';
GeoApi.CitiesPath = '/api/geo/cities';
GeoApi.NeighborhoodsPath = '/api/geo/neighborhoods';
GeoApi.OfficesPath = '/api/geo/offices';
GeoApi.OfficesSiteMap = '/api/geo/offices/sitemap';
GeoApi.RegionsPath = '/api/geo/regions';
GeoApi.SFRDistrictPath = '/api/geo/sfr-districts';



// WEBPACK FOOTER //
// ./src/PublicApi/geo/GeoApi.js


// WEBPACK FOOTER //
// webpack:///src/PublicApi/geo/GeoApi.js